import React from 'react';
import { Stack, Typography } from '@mui/material';
import { theme } from '../../constants/theme';
import { useThemeContext } from '../../hook/useThemeManager';
import { IContestSummary } from '../../redux/activity/types';

import { ContestSuggestionCard, IContestSuggestionCard } from './ContestSuggestionCard';
import { FONT_ENUM } from '../../types/global/fonts.types';

export interface IContestSuggestionGroup extends Omit<IContestSuggestionCard, 'contests'> {
    contestsgroup: IContestSummary[];
    header?: string;
}

const ContestSuggestionGroup: React.FC<IContestSuggestionGroup> = ({ contestsgroup, header, ...props }) => {
    const { themeStyle } = useThemeContext();
    return (
        <Stack
            sx={{
                border: `1px solid ${theme[themeStyle].tag_white}`,
                borderRadius: 2,
                p: 2,
                my: 2,
            }}>
            <Typography style={{ color: theme[themeStyle].tag_white, fontFamily: FONT_ENUM.MAIN_MEDIUM, fontSize: 12 }}>
                {header}
            </Typography>
            {contestsgroup.map((contest, index) => (
                <ContestSuggestionCard contests={contest} key={index} {...props} />
            ))}
        </Stack>
    );
};

export { ContestSuggestionGroup };
